export default "__VITE_ASSET__vjq7PM2k__"